module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.command),
      expression: "command"
    }],
    attrs: {
      "type": "radio",
      "value": "foreColor"
    },
    domProps: {
      "checked": _vm._q(_vm.command, "foreColor")
    },
    on: {
      "__c": function($event) {
        _vm.command = "foreColor"
      }
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$parent.locale["fore color"]) + "\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.command),
      expression: "command"
    }],
    attrs: {
      "type": "radio",
      "value": "backColor"
    },
    domProps: {
      "checked": _vm._q(_vm.command, "backColor")
    },
    on: {
      "__c": function($event) {
        _vm.command = "backColor"
      }
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$parent.locale["background color"]) + "\n        ")])]), _vm._v(" "), _c('div', [_vm._l((_vm.colors), function(color) {
    return _c('div', {
      staticClass: "color-card",
      style: ({
        'background-color': color
      }),
      on: {
        "click": function($event) {
          _vm.changeColor(color)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e8ad9ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/color/dashboard.vue
// module id = 671
// module chunks = 0